// Rounded rectangle handle path - centered vertically
// Creates a handle with rounded corners on the right side only (pill shape on right)
export const brushHandlePath = (height: number) => {
  const handleHeight = 40;
  const handleWidth = 20;
  const borderRadius = 4;
  const yOffset = (height - handleHeight) / 2; // Center vertically

  return [
    // Start at top-left of handle
    `M 0 ${yOffset}`,
    // Top edge
    `h ${handleWidth - borderRadius}`,
    // Top-right rounded corner
    `q ${borderRadius} 0, ${borderRadius} ${borderRadius}`,
    // Right edge
    `v ${handleHeight - borderRadius * 2}`,
    // Bottom-right rounded corner
    `q 0 ${borderRadius}, -${borderRadius} ${borderRadius}`,
    // Bottom edge
    `h -${handleWidth - borderRadius}`,
    // Left edge (close path)
    `z`,
  ].join(' ');
};

// Pause icon (two vertical bars) inside the handle
export const brushHandleGripLinesPath = (height: number) => {
  const barHeight = 16;
  const yOffset = (height - barHeight) / 2; // Center vertically
  const xOffset = 7; // Position from left edge of handle
  const barSpacing = 6; // Space between the two bars

  return [
    // First bar
    `M ${xOffset} ${yOffset}`,
    `v ${barHeight}`,
    // Second bar
    `M ${xOffset + barSpacing} ${yOffset}`,
    `v ${barHeight}`,
  ].join(' ');
};

export function Arrow({ color, dataTestId }: { color: string; dataTestId?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10.605"
      height="15.555"
      data-testid={dataTestId}
      style={{ overflow: 'visible' }} // Allow content to overflow for better alignment
    >
      <path
        fill={color}
        transform="rotate(180, 5.3025, 7.7775)"
        d="m2.828 15.555 7.777-7.779L2.828 0 0 2.828l4.949 4.948L0 12.727l2.828 2.828z"
      />
    </svg>
  );
}
